export const SALES_PRICE_COL_LIST = [
  { prop: "image", attrs: { label: "图片", width: "90px" }, slot: true },
  { prop: "outerId", attrs: { label: "款式编码"} },
  { prop: "title", attrs: { label: "商品名称" },slot: true },
  { prop: "skuOuterId", attrs: { label: "商品编码"} },
  { prop: "beforeSalesPrice", attrs: {label: "原销售价"}, slot: true},
  { prop: "afterSalesPrice", attrs: {label: "修改后销售价"},slot: true},
  { prop: "status", attrs: { label: "状态" }, slot: true},
  {prop: "extendVal1", attrs: { label: "同步系统资料" }, slot: true},
  { prop: "errorMessage", attrs: { label: "失败原因" ,}, slot: true},
  {prop: 'operation', attrs: { label: "操作" ,}, slot: true},
]

export const DISTRIBUTION_PRICE_COL_LIST = [
  { prop: "image", attrs: { label: "图片", width: "90px" }, slot: true },
  { prop: "outerId", attrs: { label: "款式编码"} },
  { prop: "title", attrs: { label: "商品名称" },slot: true },
  { prop: "skuOuterId", attrs: { label: "商品编码"}},
  { prop: "beforeDistributorPrice", attrs: {label: "原1-5级分销价"}, slot: true},
  { prop: "afterDistributorPrice", attrs: {label: "修改后1-5级分销价"}, slot: true},
  { prop: "status", attrs: { label: "状态" }, slot: true},
  {prop: "extendVal1", attrs: { label: "同步系统资料" }, slot: true},
  { prop: "errorMessage", attrs: { label: "失败原因" ,}, slot: true},
]

export const COL_LIST = [
  { prop: "image", attrs: { label: "图片", width: "90px" }, slot: true },
  { prop: "outerId", attrs: { label: "款式编码"} },
  { prop: "title", attrs: { label: "商品名称" },slot: true },
  { prop: "skuOuterId", attrs: { label: "商品编码"} },
  { prop: "status", attrs: { label: "状态" }, slot: true},
  { prop: "errorMessage", attrs: { label: "失败原因" ,}, slot: true},
  {prop: 'operation', attrs: { label: "操作" ,}, slot: true},
]